import React, {Component} from "react";
import FJPanelAnimation from "../../../common/component/FJPanelAnimation/FJPanelAnimation";
import FJResourcesSearchCommon from "../view/FJResourcesSearchCommon";
import FJLocalStore from "../../../store/FJLocalStore";
import FJBackgroundList from "../view/FJBackgroundList";
import styles from "../view/css/FJStockVideoContainer.module.less";
import FJUtil from "../../../util/FJUtil";
import {connect} from "react-redux";
import FJBackgroundMoreList from "../view/FJBackgroundMoreList";
import FJConfig from "../../../config/FJConfig";
import {FJMediaAction, FJStockVideoAction} from "../../../redux/action/FJRoot.action";
import FJBackgroundStore from "../../../store/FJBackgroundStore";
import $ from "jquery";
import FJMedia from "../../../store/FJMedia";
import FJCoreConstant from "../../../core/constant/FJCoreConstant";

class FJStockVideoContainer extends Component{

	constructor(props) {
		super(props);
		this.state = {
			showType: 1, // 1 代表列表 2 代表分类详情列表
      expandData: {list: []},
			backgroundLists: this._handelData(FJBackgroundStore.list),
		};
		this.classes = {
			scrollClasses: {
				trackVertical: '',
				trackHorizontal: '',
				thumbVertical: '', // styles.media_thumbVertical
				thumbHorizontal: '',
			},
			pageHeaderClasses: {
				listBox: styles.page_header_list_box,
				headerBox: styles.page_header_box,
				seeAllBox: styles.more_animation_box,
				titleBox: styles.text_animation_box,
				moreBox: styles.more_box,
			},
			pageHeaderBackClasses: {
				headerBox: styles.more_header_text,
				backBox: styles.back_more_back,
				titleBox: styles.more_title,
				backTextBox: styles.more_desc
			},
			itemClasses: {
				resourceItem: styles.item,
				resourceItemActive: styles.item_active,
				inner: styles.inner_box,
				addBtnBox: styles.add_box,
				deleteBtnBox: '',
				addBtn: styles.add_button,
				name: '',
				link: '',
				refresh: '',
				reloadIcon: ''
			}
		}
		this._config = {
			addIconToolTip: FJLocalStore._('add-to-timeline')
		};
		this._resourceViewInfo = {
      width: 140,
      height: 80,
      space: 12,
      marginBottom: 16,
		};
		this._resourceMoreViewInfo = {
			width: 144,
			height: 83,
			space: 16,
			marginBottom: 20,
		};
	}

	componentDidMount() {
	  this._onListRefresh();
  }

  _handelData = (lists) => {

	  const {SUCCESS} = FJMedia.MediaStatus();
	  const {SELF, STOCK} = FJMedia.MediaFromType();
	  const {VIDEO, IMAGE, BACKGROUND} = FJCoreConstant;
		lists.forEach((_list) => {
		  let cate = _list.category;
		  switch (_list.type) {
        case 'video':
          _list.hasStockVideoBox = true;
          _list.list = _list.list.map(item => {
            return {...item, name: item.title, type: VIDEO, status: SUCCESS, fromType: STOCK};
          });
          break;
        case 'image':
          _list.hasStockVideoBox = false;
          _list.list = _list.list.map(item => {
            return {
              ...item,
              name: cate,
              id: item.imageUrl,
              type: IMAGE,
              status: SUCCESS,
              fromType: SELF,
              thumbnail: FJConfig.photoBackgroundPath + "/" + _list.category.replace(/ /g, "-").toLowerCase() + "-thumbnail/" + item.imageUrl + "." + item.ext,
            };
          });
          break;
        case 'color':
          _list.hasStockVideoBox = false;
          _list.list = _list.list.map(item => typeof item === 'object' ? item : {type: BACKGROUND, color: item});
          break;
        default:
      }
		})
		return lists;
	}

	seeMore = (category) => {
	  let {list, status, total, type} = this.state.backgroundLists.find(item => item.category === category);
		this.setState({
      expandData: {
        title: category,
        total,
        status,
        list,
        type,
      },
			showType: 2,
		})
	}

	_backElement = () => {
		this.setState({
			showType: 1
		})
	};

  /**
   * @description 拖动资源库文件
   * @param e
   * @param data
   * @param callback
   * @private
   */
  _onMediaDrag = (e, data, callback) => {
    const {id, type} = data;
    let submitData = this._wrapSubmitData(id, type);
    if (submitData) {
      this.props.onMediaDrag(e, {...data, ...submitData}, callback, this._getDragNodeInTimeLine);
    }
  };

  /**
   * @description 得到拖动background到时间轴的样式
   * @param selfRect
   * @param dragInfo
   * @returns {HTMLDivElement}
   * @private
   */
  _getDragNodeInTimeLine = (selfRect, dragInfo) => {
    const {VIDEO, AUDIO, IMAGE, BACKGROUND} = FJCoreConstant;
    let node = document.createElement('div');
    let cssStyle = {
      width: selfRect.width,
      height: selfRect.height,
      borderColor: '#FF822C',
    };
    $(node).addClass(styles.active);
    switch (dragInfo.type) {
      case BACKGROUND:
        cssStyle = {
          ...cssStyle,
          backgroundColor: dragInfo.color,
        }
        break;
      case AUDIO:
      case IMAGE:
      case VIDEO: {
        $(node).addClass(styles.drag_other_img);
        cssStyle.borderRadius = '4px';
        if (dragInfo.type === AUDIO) {
          cssStyle.backgroundColor = '#7F809B';
          cssStyle.backgroundPosition = 'center';
        } else {
          cssStyle.backgroundImage = `url(${dragInfo.getUrl})`
        }
        break;
      }
    }
    $(node).css(cssStyle);
    return node;
  };

	_allTooltip = () => {
		FJUtil.allTooltip('u-tooltip-bottom', 'bottom');
	};

	_oneTooltip = (ele) => {
		FJUtil.oneTooltip(ele, 'bottom');
	};

	_search = (value) => {
		this.props.showStockVideoModalAction();
		this.props.searchVideo(value);
	};

	_onAddClick = (id, type) => {
	  let data = this._wrapSubmitData(id, type);
    if (data) {
      const {type, fromType, value, options} = data;
      this.props.onAddClick(type, fromType, value, options);
    }
  };

	_wrapSubmitData = (id, type) => {
    const {backgroundLists} = this.state;
    const {LOCAL} = FJMedia.MediaFromType();
    const {VIDEO, IMAGE, BACKGROUND} = FJCoreConstant;
    let result = null;
    for (let i = 0; i < backgroundLists.length; i++) {
      const {type: iType, list, category} = backgroundLists[i];
      let _type = {video: VIDEO, image: IMAGE, color: BACKGROUND}[iType];
      if (type === _type) {
        switch (type) {
          case BACKGROUND: {
            let item = list.find(item => item.color === id);
            if (item) {
              result = {
                type,
                value: id,
                fromType: LOCAL,
                options: {
                  bkType: category,
                }
              }
            }
            break;
          }
          case VIDEO:
          case IMAGE: {
            let item = list.find(item => item.id === id);
            if (item) {
              const {fromType, duration, name, thumbnail} = item;
              result = {
                type,
                value: id,
                fromType,
                options: {
                  duration,
                  thumbnail,
                  name,
                  bkType: category,
                }
              };
            }
            break;
          }
          default:
        }
        if (result) {
          break;
        }
      }
    }
    return result;
  };

	_nextPage = (category) => {
	  FJBackgroundStore.nextPage(category, (data) => {
	    if (category === this.state.expandData.title) {
        let _list = this._handelData(data);
        let {list, status, total, type} = _list.find(item => item.category === category);
        this.setState({
          backgroundLists: _list,
          expandData: {
            title: category,
            total,
            status,
            list,
            type,
          },
        });
      }
    });
  };

  _onListRefresh = () => {
    FJBackgroundStore.init((list) => {
      this.setState({backgroundLists: this._handelData(list)});
    });
  }

  _render = () => {
    const placeholder = FJLocalStore._('background search');
    let {showType, backgroundLists, expandData,} = this.state;
    return (
      <>
        <FJResourcesSearchCommon style={{display: showType === 1 ? 'flex' : 'none'}}
                                 showHistory={false}
                                 placeholder={placeholder}
                                 searchResult={this._search}
                                 backElement={this._backElement}
        />
        <FJBackgroundList isShow={showType === 1}
                          onListRefresh={this._onListRefresh}
                          classes={this.classes}
                          backgroundLists={backgroundLists}
                          seeAllText={FJLocalStore._('see-all')}
                          seeMore={this.seeMore}
                          resourceViewInfo={this._resourceViewInfo}
                          config={this._config}
                          allTooltip={this._allTooltip}
                          oneTooltip={this._oneTooltip}
                          onAddClick={this._onAddClick}
                          onMediaDrag={this._onMediaDrag}
        />
        <FJBackgroundMoreList isShow={showType === 2}
                              classes={this.classes}
                              backTitle={FJLocalStore._('back')}
                              expandData={expandData}
                              nextPage={this._nextPage}
                              backElement={this._backElement}
                              resourceViewInfo={this._resourceViewInfo}
                              config={this._config}
                              onAddClick={this._onAddClick}
                              onMediaDrag={this._onMediaDrag}
        />
      </>
    );
  };

	render() {
		let {isShow, direction} = this.props;
		return (
			<FJPanelAnimation active={isShow} direction={direction} render={this._render} />
		)
	}
}

const mapStateToProps = function (state) {
  return {
    direction: state.resource.direction,
  }
};

const mapDispatchToProps = function (dispatch) {
	return {
		onAddClick: function (type, fromType, value, options) {
      dispatch(FJMediaAction.addToTimeLineAction(type, fromType, value, options));
		},
		showStockVideoModalAction: function () {
			dispatch(FJStockVideoAction.showStockVideoPanelAction())
		},
		searchVideo: function (value) {
			dispatch(FJStockVideoAction.searchVideoWithBKAction(value))
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(FJStockVideoContainer);
